"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryReactors = void 0;

var _common = require("./../common");

var _utils = require("./../common/utils");

var _service = require("./../service");

var _CrudBuilder = require("./../service/CrudBuilder");

const BasisTheoryReactors = new _CrudBuilder.CrudBuilder(class BasisTheoryReactors extends _service.BasisTheoryService {
  constructor(options) {
    const _options = { ...options
    }; // eslint-disable-next-line unicorn/prefer-spread

    _options.transformRequest = [].concat(_utils.transformReactorRequestSnakeCase, options.transformRequest || []); // eslint-disable-next-line unicorn/prefer-spread

    _options.transformResponse = [].concat(_utils.transformReactorResponseCamelCase, options.transformResponse || []);
    super(_options);
  }

  react(reactorId, request, options) {
    return this.client.post(`/${reactorId}/react`, request, (0, _common.createRequestConfig)(options, {
      transformRequest: _common.proxyRaw,
      transformResponse: _common.proxyRaw
    })).then(_common.dataExtractor);
  }

}).create().retrieve().update().patch().delete().list().build();
exports.BasisTheoryReactors = BasisTheoryReactors;